export default __webpack_public_path__ + "images/picture_efficiently-filled-packed-loaded_container-displays.webp?4893d708cee5448786737bf7535b1c20";